"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.InvestorsDashboardEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var field_groups_1 = require("../../field-groups");
var fields_1 = require("../../fields");
var slices_1 = require("../../slices");
var document_factory_1 = require("./document-factory");
var getLastPressReleaseTab = function (prismicData, logger) {
    var lastPressReleaseTab = utils_1.unprefix('last_press_releases', prismicData);
    var title = fields_1.toText(lastPressReleaseTab === null || lastPressReleaseTab === void 0 ? void 0 : lastPressReleaseTab.title);
    var nbPressRelease = fields_1.toNumber(lastPressReleaseTab === null || lastPressReleaseTab === void 0 ? void 0 : lastPressReleaseTab.nbPressRelease) || 5;
    var cta = field_groups_1.toCta(lastPressReleaseTab, logger);
    if (!title || !cta) {
        return undefined;
    }
    return utils_1.compact({
        title: title,
        nbPressRelease: nbPressRelease,
        cta: cta
    });
};
var getDocumentInvestor = function (primary, logger) {
    var title = logger.required(fields_1.toText(primary === null || primary === void 0 ? void 0 : primary.doc_title));
    var link = logger.required(fields_1.toMediaLink(primary === null || primary === void 0 ? void 0 : primary.doc_link, logger));
    if (!title || !link) {
        return undefined;
    }
    return utils_1.compact({
        title: title,
        link: link
    });
};
var getInvestorPresentation = function (prismicData, logger) {
    var investorPresentation = utils_1.unprefix('investor_presentation', prismicData);
    if (!investorPresentation) {
        return undefined;
    }
    var title = logger.required(fields_1.toText(investorPresentation === null || investorPresentation === void 0 ? void 0 : investorPresentation.title));
    var date = logger.required(fields_1.toText(investorPresentation === null || investorPresentation === void 0 ? void 0 : investorPresentation.date));
    var cta = logger.required(field_groups_1.toCta(investorPresentation, logger));
    var document = getDocumentInvestor(investorPresentation, logger);
    if (!title || !date || !cta || !document) {
        return undefined;
    }
    return utils_1.compact({
        title: title,
        date: date,
        cta: cta,
        document: document
    });
};
var getLastFinancialResults = function (prismicData, logger) {
    var _a;
    var lastFinancialResults = utils_1.unprefix('last_financial_results', prismicData);
    if (!lastFinancialResults) {
        return undefined;
    }
    var title = logger.required(fields_1.toText(lastFinancialResults === null || lastFinancialResults === void 0 ? void 0 : lastFinancialResults.title));
    var subtitle = logger.required(fields_1.toText(lastFinancialResults === null || lastFinancialResults === void 0 ? void 0 : lastFinancialResults.subtitle));
    var date = logger.required(fields_1.toText(lastFinancialResults === null || lastFinancialResults === void 0 ? void 0 : lastFinancialResults.date));
    var cta = logger.required(field_groups_1.toCta(lastFinancialResults, logger));
    if (!title || !subtitle || !date || !cta) {
        return undefined;
    }
    return utils_1.compact({
        title: title,
        subtitle: subtitle,
        date: date,
        cta: cta,
        documents: logger.required((_a = slices_1.processSlices({ financial_doc: processLastFinancialResults }, lastFinancialResults === null || lastFinancialResults === void 0 ? void 0 : lastFinancialResults.slices, logger)) === null || _a === void 0 ? void 0 : _a.filter(Boolean))
    });
};
var processLastFinancialResults = function (_a, logger) {
    var primary = _a.primary;
    return getDocumentInvestor(primary, logger);
};
exports.InvestorsDashboardEntity = document_factory_1.documentFactory(types_1.DocumentType.INVESTORS_DASHBOARD, function (prismicDoc, normalizedDoc, logger) {
    return utils_1.compact(__assign(__assign({}, normalizedDoc), { last_financial_results: getLastFinancialResults(prismicDoc.data, logger), investor_presentation: getInvestorPresentation(prismicDoc.data, logger), last_press_releases: getLastPressReleaseTab(prismicDoc.data, logger) }));
});
//# sourceMappingURL=investors-dashboard.js.map